const Logo = <template>
  <nav>
    <div class="logo">
      <img
        src="/images/logos/HCP-Horizontal_onLight.svg"
        aria-hidden="true"
        height="29"
      />
    </div>
  </nav>
</template>;
export default Logo;
